var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-copyright" }, [
    _c("p", [
      _vm._v(
        "© " +
          _vm._s(_vm.getConstants("YEAR")) +
          " " +
          _vm._s(_vm.getConstants("SHANGHAI_YIJING"))
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }